export default __webpack_public_path__ + "static/media/status_on.79112431.svg";